import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'
import { mq, spacing } from 'core/theme'
import { usePageContext } from 'core/helpers/pageContext'
import LanguageSwitcher from 'core/i18n/LanguageSwitcher'
import PaginationLink from './PaginationLink'

const Pagination = (/*{
    toggleSidebar,
    showSidebar,
    closeSidebar,
    pagination
}: {
    toggleSideBar: any
    showSidebar: any
    closeSidebar: any
    pagination: any
}*/) => {
    const context = usePageContext()

    let previous = <span />
    if (context.previous !== undefined && !isEmpty(context.previous)) {
        previous = (
            <PaginationLink
                className="PaginationPrevious"
                page={context.previous}
                type="previous"
            />
        )
    }

    let next = <span />
    if (context.next !== undefined && !isEmpty(context.next)) {
        next = <PaginationLink className="PaginationNext" page={context.next} type="next" />
    }

    return (
        <Container className="Pagination">
            {previous}
            {next}
        </Container>
    )
}

Pagination.defaultProps = {
    toggleSidebar: PropTypes.func.isRequired
}

const Container = styled.div`
    /* z-index: 10; */
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media ${mq.smallMedium} {
        border-bottom: none;
        grid-template-columns: 1fr 0px 1fr;
    }
`

const MiddleContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export default Pagination
